module.exports = new __parcel__URL__("the-sixth-sense.b1863ca8.jpg").toString();